import type { ClassValue } from "clsx"

import { cn } from "@/lib/utils"

// `text-base sm:text-[0.95rem]` is the field's own size and belongs here rather
// than at each call site. iOS Safari zooms the whole page in when a focused
// control renders below 16px, and it does NOT zoom back out when the field
// loses focus, so a visitor who taps an email box is left on a magnified,
// sideways-scrolling page for the rest of his visit. 16px on a phone is the
// threshold that prevents it; the designed 0.95rem stands from `sm` up, where
// no phone keyboard is involved.
//
// A call site that needs a different size must pass a RESPONSIVE pair
// (`text-base sm:text-[…]`). Passing a bare `text-[…]` silently defeats this:
// tailwind-merge drops the unprefixed `text-base` above in favour of the later
// class, and the field goes back to zooming.
export function marketingFieldClass({ className }: { className?: ClassValue } = {}) {
  return cn(
    "rounded-[var(--radius-sm)] border border-[var(--color-rule-strong)] bg-[var(--color-paper-high)] text-base text-[var(--color-ink)] outline-none transition-colors placeholder:text-[var(--color-ink-soft)] hover:border-[var(--color-ink-soft)] focus:border-[var(--color-vermilion)] focus-visible:ring-2 focus-visible:ring-[var(--color-vermilion)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-paper)] sm:text-[0.95rem]",
    className,
  )
}
